import { render, staticRenderFns } from "./ModalCarousel6.vue?vue&type=template&id=910a6e94&scoped=true&"
import script from "./ModalCarousel6.vue?vue&type=script&lang=js&"
export * from "./ModalCarousel6.vue?vue&type=script&lang=js&"
import style0 from "./ModalCarousel6.vue?vue&type=style&index=0&id=910a6e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910a6e94",
  null
  
)

export default component.exports